import {Collapse, Divider, Modal} from "antd";
import React, {useEffect} from "react";
import moment from "moment";

function CustomDivider({ className }) {
  return <Divider className={`my-0.5 ${className}`} />;
}

// export default const EmptyList(props) {
//   return (
//     <div className={`bg-white p-3 h-64 rounded-md mb-2 ${props.className}`}>
//       <div className="flex-1 items-center justify-center rounded-md border-1 border-dashed border-[#c5ccd2] bg-[#8eacc90a] p-2">
//         <LazyLoadImage src={SvgAssets.EmptySvg} className="w-36 md:w-40" />
//         <label className="text-base md:text-lg font-battambang text-[#919eab] mb-1">មិនមានទិន្នន័យ</label>
//       </div>
//     </div>
//   );
// }


const SportDetailModal = ({open, onClose, details}) => {
  // const details= lists?.data?.detailList ? lists?.data?.detailList : [];


  const renderBetResult = (_betResult) => {
    if (_betResult === '0') {
      return <span className=""></span>;
    } else if (_betResult === '2') {
      return <></>;
    }
    if (_betResult === '3') {
      return (
        <span className="text-md inline-flex items-center rounded-md bg-red-50 px-2 py-1 text-xs font-medium text-red-700 ring-1 ring-red-600/10 ring-inset">
          ចាញ់
        </span>
      );
    } else if (_betResult === '4') {
      return (
        <span className="text-md inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-700 ring-1 ring-green-600/20 ring-inset">
          ឈ្នះ
        </span>
      );
    } else if (_betResult === '6') {
      return (
        <span className="text-md inline-flex items-center rounded-md bg-red-50 px-2 py-1 text-xs font-medium text-red-700 ring-1 ring-red-600/10 ring-inset">
          ចាញ់​​ 0.5
        </span>
      );
    } else {
    }
  };

  return (
    <Modal open={open} onCancel={onClose} footer={null} width={650} >
      <div className="flex-1 items-center justify-center">
        <div
          className={`bg-white p-2 rounded-2xl w-full max-w-3xl relative border-5 border:bg-slate-100`}
          onClick={() => {
          }}>
          <div className={`mb-2 flex-row items-center w-full rounded`}>
            <label className="text-base md:text-xl text-[#333] font-battambang">របាយការណ៍លម្អិត</label>
          </div>

          {details?.map((itm, key) => {
            return (
              <div key={key} className={`flex-col my-1 px-0 hover:bg-[#FFD] border-b-[2px] cursor-pointer gap-2`}>
                <hr className="border-[1.5px]"/>
                <div className="flex flex-row border-x-[2px]">
                  <div className={`p-1 w-[70px] md:w-[120px] flex flex-col items-center justify-center gap-1 border-r border-dashed border-gray-300`}>
                    <p className="m-0 p-0 text-xs md:text-sm">{moment(itm?.beginTime || '').format('YYYY-MM-DD')}</p>
                    <p className="m-0 p-0 text-md">{moment(itm?.beginTime || '').format('hh:mm')}</p>
                  </div>


                  <div className={`flex-1 px-2 py-2 flex-cols justify-center gap-1 `}>
                    <div className="flex flex-row">
                      <span className="p-0 flex-1 text-xs md:text-sm">
                        {itm?.playOptionName} <strong>({itm?.playName})</strong>
                      </span>
                      <span className="p-0 text-xs md:text-sm font-bold"> {itm.oddFinallyStr}</span>
                    </div>
                    <div className="flex flex-row">
                      <span className="p-0 flex-1 text-xs md:text-sm text-gray-600">{itm?.matchInfo}</span>
                    </div>
                    <div className="flex flex-row">
                      <span className="p-0 flex-1 text-xs md:text-sm text-gray-600">{itm?.matchName}</span>
                      <span className="p-0 text-xs md:text-sm text-gray-500">
                        {renderBetResult(itm?.betResult || '')}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}

          {/*{!lists && (*/}
          {/*  <div>*/}
          {/*    <EmptyList/>{' '}*/}
          {/*  </div>*/}
          {/*)}*/}

          {/*<div className="flex items-end w-full mt-4 ">*/}
          {/*  <button*/}
          {/*    autoFocus*/}
          {/*    onClick={() => onClose}*/}
          {/*    className={`rounded-md p-2 w-full md:w-[200px] text-sm md:text-base font-battambang bg-gray-200 border-1 `}>*/}
          {/*    បិត*/}
          {/*  </button>*/}
          {/*</div>*/}
        </div>
      </div>
    </Modal>
  )
}

export default SportDetailModal